import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from '@angular/core';
import {FilterBlock} from "../../../search/search-list/filters/filter-block/filter-block";
import {TranslateService} from "../../translate.service";
import {BehaviorSubject} from "rxjs/index";
import {FacetService} from "./facet.service";

@Component({
  selector: 'app-facets',
  templateUrl: './facets.component.html',
  styleUrls: ['./facets.component.scss']
})
export class FacetsComponent implements OnInit {

  @Input() buttonsInComponent = true;

  groupedFilters: FilterBlock[] = [];

  filtersActive: boolean = true;

  @Input() sortActive: boolean = false;
  displaySort = false;

  @Output() init = new BehaviorSubject<boolean>(false);

  refreshFilterEmitter = new EventEmitter<boolean>(false);

  constructor(
    private facetService: FacetService,
    public translateService: TranslateService) {
  }

  ngOnInit() {
    let tempGroupedFilters;
    this.facetService.allRegularFacets.subscribe(filters => {
      this.init.next(this.init.value || filters.length > 0);
      const types = filters.filter(filter => filter.field === '_type').filter(filter => filter.selected);
      tempGroupedFilters = [];
      this.facetService.getConfigs().forEach(filterConfig => {
        let filtersByField = this.facetService.getFiltersByField(filters, filterConfig.name);
        let childFiltersByField = this.facetService.getChildFilterBlocks(filterConfig.additionalConfigs, filters);
        if (this.facetService.hasResults(filterConfig, childFiltersByField, filtersByField)) {
          tempGroupedFilters.push(new FilterBlock(filterConfig, filtersByField, childFiltersByField));
        }
      });
      this.updateOrRecreateFilters(tempGroupedFilters);
    });
  }

  updateOrRecreateFilters(tempGroupedFilters: FilterBlock[]){
    if ((this.groupedFilters && tempGroupedFilters) && this.groupedFilters.length === tempGroupedFilters.length) {
      for (let i = 0; i < tempGroupedFilters.length; i++) {
        if (this.groupedFilters[i].isDefault()) {
          this.groupedFilters[i].filters = tempGroupedFilters[i].filters;
          this.groupedFilters[i].childFilterBlocks = tempGroupedFilters[i].childFilterBlocks;
        } else {
          this.groupedFilters[i] = tempGroupedFilters[i];
        }
      }
    } else {
      this.groupedFilters = tempGroupedFilters;
    }
    this.refreshFilterEmitter.emit(true);
  }

  toggleFilters() {
    this.filtersActive = !this.filtersActive;
  }

  toggleSort() {
    console.log("toggleSort");
    this.displaySort = !this.displaySort;
    // this.sortActive = !this.sortActive;
  }

  isYear(filterBlock: FilterBlock) {
    return filterBlock.filterConfig && filterBlock.filterConfig.renderer && filterBlock.filterConfig.renderer.startsWith('range');
  }

  preventDef(event) {
    if (event) {
      event.preventDefault();
    }
  }

  hideFiltersLabel() {
    return this.translateService.translate('filters.label');
  }

}
